export const visit = (vm, at) => {
vm(require("SharedI18nStrings/lang/languageNames/en.lyaml"));
at({ "en": { "videoData": { "time": { "abbreviations": { "hour": "hr", "minute": "min", "second": "sec" } } } } });
};